import { render, staticRenderFns } from "./assignmentDialog.vue?vue&type=template&id=2ea07b55&scoped=true&"
import script from "./assignmentDialog.vue?vue&type=script&lang=js&"
export * from "./assignmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./assignmentDialog.vue?vue&type=style&index=0&id=2ea07b55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea07b55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea07b55')) {
      api.createRecord('2ea07b55', component.options)
    } else {
      api.reload('2ea07b55', component.options)
    }
    module.hot.accept("./assignmentDialog.vue?vue&type=template&id=2ea07b55&scoped=true&", function () {
      api.rerender('2ea07b55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/mawb/assignmentDialog.vue"
export default component.exports